export default __webpack_public_path__ + "static/media/Cross.3f9236a0.svg";